import { useTranslation } from 'react-i18next';
import { Icon, Tooltip } from '@anytag/shared-atoms';
import { useCopy } from '@anytag/shared-hooks';
import { useChatRoomContext } from '../chat-room-context';

export interface CopyButtonProps {
  copyText?: string;
}

export const CopyButton = ({ copyText }: CopyButtonProps) => {
  const { t } = useTranslation();
  const { copyToClipboard } = useCopy();
  const { setToastMessage } = useChatRoomContext();

  return (
    <Tooltip help={t<string>('Tooltip.Copy')}>
      <div
        className="flex"
        onClick={() => {
          if (copyText) {
            copyToClipboard(copyText, false);
            setToastMessage({ type: 'success', message: t('chatboxCopyTextSuccess') });
          }
        }}
      >
        <Icon icon="copy" size={11} variant="gray" className="hover:cursor-pointer hover:opacity-85" />
      </div>
    </Tooltip>
  );
};
